enum Assignable {
  PROJECT = "project",
  LIST = "list",
  TASK = "task",
  MILESTONE = "milestone",
  RESSOURCE = "ressource",
  EVENT = "event",
}

export { Assignable };
